import { GlobalState } from "App";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export const useForgotPassword = () => {
  const navigate = useNavigate();
  const { authBackUrl } = useContext(GlobalState);
  const formCode = authBackUrl ? authBackUrl.split("/")[2] : null;
  const [resendDelay, setResendDelay] = useState(0);

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isSentDialogOpen, setIsSentDialogOpen] = useState(false);
  const currentYear = new Date().getFullYear();

  const isValid = !emailError && email;

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (e.target.validity.valid) {
      setEmailError(false);
    } else {
      setEmailError(true);
    }
  };

  const handleSubmit = async () => {
    if (!isValid) return;

    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_V2_URL}/auth/reset-password-request/request-otp`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, formCode }),
        }
      );
      const result = await response.json();

      if (response?.status !== 200 || result?.error) {
        setError(result?.message ?? result?.error ?? "Something went wrong");
        setLoading(false);
        return;
      }

      setIsSentDialogOpen(true);
      setResendDelay(30);
    } catch (error) {
      setError(error?.message ?? error?.error ?? "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleNotificationClose = () => {
    navigate(authBackUrl ?? "/");
    setIsSentDialogOpen(false);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (resendDelay > 0) {
        setResendDelay((prev) => prev - 1);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [resendDelay]);

  return {
    email,
    handleEmailChange,
    emailError,
    handleSubmit,
    error,
    setError,
    loading,
    isSentDialogOpen,
    handleNotificationClose,
    currentYear,
    isValid,
    authBackUrl,
    resendDelay,
  };
};
